
export const fetchSheetData = async (sheetId) => {
  try {
    const catRes = await fetch(`https://opensheet.elk.sh/${sheetId}/Categories`);
    const categories = await catRes.json();

    const categoryDescriptions = {};
    categories.forEach((row) => {
      categoryDescriptions[row.Category] = row.Description;
    });

    const prodRes = await fetch(`https://opensheet.elk.sh/${sheetId}/Products`);
    const products = await prodRes.json();

    const productsData = {};
    products.forEach((row) => {
      const category = row.Category.trim();
      if (!productsData[category]) productsData[category] = [];
      productsData[category].push({
        name: row["Product Name"],
        desc: row.Description,
        img: row["Image URL"],
      });
    });

    return { categoryDescriptions, productsData };
  } catch (error) {
    console.error("Error fetching Google Sheet data:", error);
    return { categoryDescriptions: {}, productsData: {} };
  }
};
